<template>
  <div id="webCams">
    <h2 class="mt-2">Web Cams</h2>
    <div
      v-if="webcamPopup == false"
      class="row"
    >
      <div
        v-for="(webcam, index) in webcams"
        class="col-sm-4"
      >
        <div class="card">
          <img class="card-img-top" :src="webcam.thumbnail">
          <div class="card-body">
            <h5>{{ webcam.title }}</h5>
            <button
              @click="launchCam(index)"
              class="btn btn-outline-dark"
            >
              <i class="fas fa-video"></i> View Live Cam
            </button>
          </div><!-- /.card-body -->
        </div><!-- /.card -->
      </div><!-- /.col-sm-4 -->
    </div><!-- /.row -->
    <!-- Webcam Popup -->
    <div
      v-if="webcamPopup == true"
      class="webcam-popup"
    >
      <button
        @click="webcamPopup = false"
        class="btn btn-outline-light mb-2"
      >
        <i class="fas fa-arrow-left"></i> Back to all Webcams
      </button>
      <div class="embed-responsive embed-responsive-16by9">
        <iframe class="embed-responsive-item" :src="selectedCam.embedURL" allowfullscreen></iframe>
      </div>
    </div><!-- /.webcam-popup -->
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      webcamPopup: false,
      selectedCam: {},
      webcams: []
    }
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  mounted() {
    let self = this;
    setTimeout(function() {
      self.initWebcams()
    }, 500)
  },
  methods: {
    initWebcams() {
      function youtube_parser(url){
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);
        return (match&&match[7].length==11)? match[7] : false;
      }
      let timeStamp = new Date().getTime()
      this.webcams = this.dashboard.data.modules.webcams.cams
      for (let i = 0; i < this.webcams.length; i++) {
        let thisCam = this.webcams[i]
        // convert the URL into youtube ID
        let youtubeId = youtube_parser(thisCam.url)
        // create embedURL
        thisCam.embedURL = 'https://www.youtube.com/embed/' + youtubeId
        // create thumbnail
        thisCam.thumbnail = 'https://i.ytimg.com/vi/' + youtubeId + '/maxresdefault_live.jpg?nocache=' + timeStamp
      }
    },
    launchCam(index) {
      this.selectedCam = this.webcams[index]
      this.webcamPopup = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/WebCams.vue